<div class="tenant-group-management">
  <!-- Header with buttons -->
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h5 class="mb-0">
      <i class="bi bi-diagram-3 me-2"></i>
      {{ 'TenantGroupManagement.title' | translate }}
    </h5>
    
    <button type="button" class="btn btn-primary btn-sm" (click)="openCreateModal()" [disabled]="!isUserAdmin"
            [title]="!isUserAdmin ? ('TenantGroupManagement.adminRequired' | translate) : ('TenantGroupManagement.createGroup' | translate)">
      <i class="bi bi-plus-circle me-1"></i>
      {{ 'TenantGroupManagement.createGroup' | translate }}
    </button>
  </div>

  <!-- Smart Grid -->
  <div class="row" *ngIf="columns.length > 0 && !loading">
    <div class="col-12">
      <konti-smart-grid 
        [data]="tenantGroups?.rows || []" 
        [columns]="columns" 
        [initialSort]="[{ field: 'groupName', dir: 'asc' }]"
        [showGroupPanel]="false">
        
        <!-- Actions column template -->
        <ng-template appSmartGridCell="actions" let-row>
          <div class="action-capsule btn-group btn-group-sm sg-desktop-only">
            <button type="button" class="btn btn-outline-secondary" 
                    (click)="openEditModal(row)"
                    [disabled]="!isUserAdmin"
                    [title]="'General.edit' | translate">
              <i class="bi bi-pencil" aria-hidden="true"></i>
              <span class="visually-hidden">{{ 'General.edit' | translate }}</span>
            </button>
            <button type="button" class="btn btn-outline-danger action-danger" 
                    (click)="openDeleteModal(row)"
                    [disabled]="!isUserAdmin"
                    [title]="'General.delete' | translate">
              <i class="bi bi-trash3" aria-hidden="true"></i>
              <span class="visually-hidden">{{ 'General.delete' | translate }}</span>
            </button>
          </div>
        </ng-template>
      </konti-smart-grid>
    </div>
  </div>

  <!-- Loading state -->
  <div *ngIf="loading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <!-- Empty state -->
  <div *ngIf="!loading && tenantGroups.rows.length === 0" class="text-center py-5">
    <i class="bi bi-diagram-3 display-1 text-muted"></i>
    <h5 class="text-muted mt-3">{{ 'TenantGroupManagement.noGroups' | translate }}</h5>
    <p class="text-muted">{{ 'TenantGroupManagement.noGroupsDesc' | translate }}</p>
    <button type="button" class="btn btn-primary" (click)="openCreateModal()" [disabled]="!isUserAdmin">
      <i class="bi bi-plus-circle me-1"></i>
      {{ 'TenantGroupManagement.createFirstGroup' | translate }}
    </button>
  </div>
</div>

<!-- Delete Confirmation Modal -->
<ng-template #deleteConfirmModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      <i class="bi bi-exclamation-triangle text-warning me-2"></i>
      {{ 'TenantGroupManagement.confirmDeleteTitle' | translate }}
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancelDelete()"></button>
  </div>
  <div class="modal-body">
    <p>{{ 'TenantGroupManagement.confirmDeleteMessage' | translate }}</p>
    <p class="fw-bold">{{ groupToDelete?.groupName }}</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancelDelete()">
      {{ 'General.cancel' | translate }}
    </button>
    <button type="button" class="btn btn-danger" (click)="confirmDelete()">
      <i class="bi bi-trash3 me-1"></i>
      {{ 'General.delete' | translate }}
    </button>
  </div>
</ng-template>
